import axios from 'axios';
import {
    getAuthHeader
} from "@/services/user.service.js";

export {
    GetComments,
    SaveComment,
    CreateComment,
    DeleteComment
};

function GetComments(contractId, versionId, editionId, onSuccess, onError){

    var headers = getAuthHeader();
    axios
        .get(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/comments`, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            console.log(error)
            onError(error);
        });
}

function SaveComment(contractId, versionId, editionId, comment, onSuccess, onError){

    var headers = getAuthHeader();
    
    axios
        .put(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/comments/${comment.id}`, comment, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function CreateComment(contractId, versionId, editionId, comment, onSuccess, onError){

    var headers = getAuthHeader();
    
    axios
        .post(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/comments`, comment, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function DeleteComment(contractId, versionId, editionId, comment, onSuccess, onError){

    var headers = getAuthHeader();
    
    axios
    .delete(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/comments/${comment.id}`, headers)
    .then(() => {
            onSuccess(); 
        })
        .catch(error => {
            onError(error);
        });
}
